import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { screenNames } from './screenNames';
import { AppbarScreenOptions, DefaultModalOptions, DefaultScreenOptions } from '../components/NavigatorAppbar';
import { useI18n } from '../context/I18nContext';
import { SubscriptionsRouteParams, SubscriptionsScreen } from '../screens/Subscriptions/SubscriptionsScreen';
import {
  SubscriptionDetailScreen,
  SubscriptionDetailRouteParams,
} from '../screens/Subscriptions/SubscriptionDetailScreen';
import SelectPaymentMethod from '../payment/screens/SelectPaymentMethod';
import { SpaceInfo, SpaceInfoRouteParams } from '../screens/SpaceInfo';
import {
  ConfirmSubscriptionDialog,
  ConfirmSubscriptionDialogRouteParams,
} from '../screens/Subscriptions/ConfirmSubscriptionDialog';
import {
  ConfirmSubscriptionCancelDialog,
  ConfirmSubscriptionCancelDialogRouteParams,
} from '../screens/Subscriptions/ConfirmSubscriptionCancelDialog';
import OnlinePage, { OnlinePageRouteParams } from '../screens/OnlinePage';

export type SubscriptionsStackRouteParams = {
  [screenNames.SubscriptionsScreen]: SubscriptionsRouteParams;
  [screenNames.SubscriptionDetailScreen]: SubscriptionDetailRouteParams;
  [screenNames.PaymentChangeBeforeCheckoutView]: undefined;
  [screenNames.ConfirmSubscriptionDialog]: ConfirmSubscriptionDialogRouteParams;
  [screenNames.ParkingTerms]: OnlinePageRouteParams | undefined;
  [screenNames.ConfirmSubscriptionCancelDialog]: ConfirmSubscriptionCancelDialogRouteParams;
  [screenNames.SpaceInfo]: SpaceInfoRouteParams;
};

const Stack = createStackNavigator<SubscriptionsStackRouteParams>();

export default function SubscriptionsStackNavigator() {
  const { I18n } = useI18n();

  return (
    <Stack.Navigator initialRouteName={screenNames.SubscriptionsScreen} screenOptions={DefaultScreenOptions}>
      <Stack.Screen
        name={screenNames.SubscriptionsScreen}
        component={SubscriptionsScreen}
        options={{
          title: I18n.t('subscriptions.title'),
        }}
      />
      <Stack.Screen
        name={screenNames.SubscriptionDetailScreen}
        component={SubscriptionDetailScreen}
        options={{
          title: I18n.t('subscriptions.detail.title'),
        }}
      />
      <Stack.Screen
        name={screenNames.PaymentChangeBeforeCheckoutView}
        component={SelectPaymentMethod}
        options={{
          ...DefaultScreenOptions,
          title: I18n.t('payment.changePayment'),
        }}
      />
      <Stack.Screen
        name={screenNames.ConfirmSubscriptionDialog}
        component={ConfirmSubscriptionDialog}
        options={DefaultModalOptions}
      />
      <Stack.Screen name={screenNames.ParkingTerms} component={OnlinePage} options={AppbarScreenOptions} />
      <Stack.Screen
        name={screenNames.ConfirmSubscriptionCancelDialog}
        component={ConfirmSubscriptionCancelDialog}
        options={DefaultModalOptions}
      />
      <Stack.Screen
        name={screenNames.SpaceInfo}
        component={SpaceInfo}
        options={{
          ...DefaultScreenOptions,
          title: I18n.t('mapview.spaceInfo.headerTitle'),
        }}
      />
    </Stack.Navigator>
  );
}
